export default __webpack_public_path__ + "static/media/ZAP.a96cc64c.png";